import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from '@react-pdf/renderer';

const colors = {
  blue: '#2e86b5',
  text: '#222222',
  gray: '#7f8b9d',
  border: '#d7dce2',
  lightGray: '#f3f5f7',
  midGray: '#e6eaee',
  darkLine: '#7b8794',
  white: '#ffffff',
};

const styles = StyleSheet.create({
  page: {
    paddingTop: 24,
    paddingBottom: 46,
    paddingHorizontal: 22,
    fontSize: 9,
    color: colors.text,
    fontFamily: 'Helvetica',
    backgroundColor: colors.white,
  },
  reportFrame: {
    borderWidth: 1,
    borderColor: colors.darkLine,
    padding: 8,
  },
  topBand: {
    flexDirection: 'row',
    alignItems: 'stretch',
    borderWidth: 1,
    borderColor: colors.darkLine,
  },
  topBandCell: {
    justifyContent: 'center',
    paddingHorizontal: 8,
    paddingVertical: 5,
  },
  topBandSide: {
    width: 116,
    borderRightWidth: 1,
    borderRightColor: colors.darkLine,
  },
  topBandRight: {
    width: 116,
    borderLeftWidth: 1,
    borderLeftColor: colors.darkLine,
    alignItems: 'flex-end',
  },
  topBandCenter: {
    flex: 1,
    alignItems: 'center',
  },
  reportTitle: {
    fontSize: 11,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  subTitle: {
    fontSize: 7,
    color: colors.gray,
    marginTop: 1,
  },
  infoTable: {
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: colors.darkLine,
    marginBottom: 8,
  },
  infoRow: {
    flexDirection: 'row',
    minHeight: 22,
    borderTopWidth: 1,
    borderTopColor: colors.darkLine,
  },
  infoLabel: {
    width: 92,
    backgroundColor: colors.lightGray,
    borderRightWidth: 1,
    borderRightColor: colors.darkLine,
    paddingHorizontal: 6,
    paddingVertical: 5,
    fontSize: 8,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  infoValue: {
    flex: 1,
    paddingHorizontal: 6,
    paddingVertical: 5,
    fontSize: 8.5,
  },
  infoRightLabel: {
    width: 72,
    backgroundColor: colors.lightGray,
    borderLeftWidth: 1,
    borderLeftColor: colors.darkLine,
    borderRightWidth: 1,
    borderRightColor: colors.darkLine,
    paddingHorizontal: 6,
    paddingVertical: 5,
    fontSize: 8,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  infoRightValue: {
    width: 106,
    paddingHorizontal: 6,
    paddingVertical: 5,
    fontSize: 8.5,
  },
  sectionBand: {
    backgroundColor: colors.midGray,
    borderWidth: 1,
    borderColor: colors.darkLine,
    paddingHorizontal: 8,
    paddingVertical: 4,
    marginBottom: 6,
  },
  sectionBandText: {
    fontSize: 8.5,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  questionTable: {
    borderWidth: 1,
    borderColor: colors.darkLine,
    marginBottom: 12,
  },
  operariosTable: {
    borderWidth: 1,
    borderColor: colors.darkLine,
    marginBottom: 12,
  },
  questionHeader: {
    flexDirection: 'row',
    backgroundColor: colors.lightGray,
    borderBottomWidth: 1,
    borderBottomColor: colors.darkLine,
    minHeight: 24,
  },
  questionRow: {
    flexDirection: 'row',
    minHeight: 28,
    borderBottomWidth: 1,
    borderBottomColor: colors.border,
  },
  operarioItemCol: {
    width: 44,
    borderRightWidth: 1,
    borderRightColor: colors.darkLine,
    paddingHorizontal: 4,
    paddingVertical: 5,
    fontSize: 7.5,
    textAlign: 'center',
  },
  operarioLegajoCol: {
    width: 120,
    borderRightWidth: 1,
    borderRightColor: colors.darkLine,
    paddingHorizontal: 6,
    paddingVertical: 5,
    fontSize: 7.5,
    textAlign: 'center',
  },
  operarioNombreCol: {
    flex: 1,
    paddingHorizontal: 6,
    paddingVertical: 5,
    fontSize: 7.5,
    lineHeight: 1.35,
  },
  altRow: {
    backgroundColor: '#fafafa',
  },
  colNumber: {
    width: 28,
    borderRightWidth: 1,
    borderRightColor: colors.darkLine,
    paddingHorizontal: 4,
    paddingVertical: 5,
    fontSize: 7.5,
    fontWeight: 700,
  },
  colQuestion: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: colors.darkLine,
    paddingHorizontal: 6,
    paddingVertical: 5,
    fontSize: 7.5,
    lineHeight: 1.35,
  },
  colCompetency: {
    width: 68,
    paddingHorizontal: 6,
    paddingVertical: 5,
    fontSize: 7.5,
    textAlign: 'center',
  },
  evidenceGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginHorizontal: -4,
    marginBottom: 12,
  },
  evidenceCard: {
    width: '50%',
    paddingHorizontal: 4,
    marginBottom: 10,
  },
  evidenceFrame: {
    borderWidth: 1,
    borderColor: colors.darkLine,
    minHeight: 170,
    backgroundColor: colors.white,
  },
  evidenceImage: {
    width: '100%',
    height: 132,
    objectFit: 'cover',
  },
  evidencePlaceholder: {
    height: 132,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.lightGray,
    paddingHorizontal: 10,
  },
  evidenceCaption: {
    borderTopWidth: 1,
    borderTopColor: colors.darkLine,
    paddingHorizontal: 6,
    paddingVertical: 5,
    fontSize: 7.5,
    color: colors.gray,
  },
  signatureTable: {
    borderWidth: 1,
    borderColor: colors.darkLine,
    marginTop: 6,
  },
  signatureHeader: {
    flexDirection: 'row',
    backgroundColor: colors.lightGray,
    borderBottomWidth: 1,
    borderBottomColor: colors.darkLine,
  },
  signatureCellHeader: {
    flex: 1,
    paddingHorizontal: 6,
    paddingVertical: 4,
    fontSize: 7.5,
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  signatureBody: {
    flexDirection: 'row',
    minHeight: 86,
  },
  signatureCell: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: colors.darkLine,
    paddingHorizontal: 6,
    paddingVertical: 6,
    justifyContent: 'center',
  },
  signatureCellLast: {
    borderRightWidth: 0,
  },
  signatureImage: {
    width: '100%',
    height: 64,
    objectFit: 'contain',
  },
  signaturePlaceholder: {
    fontSize: 8,
    color: colors.gray,
    textAlign: 'center',
  },
  pageFooter: {
    position: 'absolute',
    bottom: 18,
    left: 22,
    right: 22,
    alignItems: 'center',
  },
  pageNumberWrap: {
    backgroundColor: '#b7b7b7',
    borderRadius: 2,
    minWidth: 74,
    paddingVertical: 4,
    paddingHorizontal: 10,
    alignItems: 'center',
  },
  pageNumberText: {
    color: colors.white,
    fontSize: 9,
    fontWeight: 700,
  },
  pageMetaText: {
    marginTop: 3,
    fontSize: 7,
    color: colors.gray,
    textTransform: 'uppercase',
  },
});

const logoSrc =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjQiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAxMjQgMzYiPgogIDxjaXJjbGUgY3g9IjE4IiBjeT0iMTYiIHI9IjciIGZpbGw9IiNlYzViOTMiIGZpbGwtb3BhY2l0eT0iMC45Ii8+CiAgPGNpcmNsZSBjeD0iMjQiIGN5PSIxMiIgcj0iOCIgZmlsbD0iIzZmM2ZjNyIgZmlsbC1vcGFjaXR5PSIwLjg1Ii8+CiAgPGNpcmNsZSBjeD0iMzEiIGN5PSIyMCIgcj0iOCIgZmlsbD0iI2YzZDI1ZSIgZmlsbC1vcGFjaXR5PSIwLjkiLz4KICA8Y2lyY2xlIGN4PSIxMSIgY3k9IjIyIiByPSI2IiBmaWxsPSIjNzBiOGY2IiBmaWxsLW9wYWNpdHk9IjAuOSIvPgogIDx0ZXh0IHg9IjUwIiB5PSIyMSIgZm9udC1zaXplPSIxNCIgZm9udC1mYW1pbHk9IkhlbHZldGljYSIgZm9udC13ZWlnaHQ9IjcwMCIgZmlsbD0iIzE2MTYxNiI+RFAgV09STEQ8L3RleHQ+Cjwvc3ZnPg==';

function formatAnswer(answer) {
  if (answer === 'si') {
    return 'Si';
  }

  if (answer === 'no aplica') {
    return 'No aplica';
  }

  if (answer === 'no') {
    return 'No';
  }

  return '-';
}

function getEvidenceItems(preguntas) {
  return preguntas.filter((item) => item.evidencia);
}

function getReportTitle(evaluacion) {
  if (evaluacion.tipoReporte === 'amarre') {
    return 'Reporte Amarre';
  }

  if (evaluacion.tipoReporte === 'toolbox') {
    return 'Reporte Toolbox';
  }

  return 'Evaluacion Trianual';
}

function InformeEvaluacionPDF({ evaluacion }) {
  const evidencias = getEvidenceItems(evaluacion.preguntas);
  const operariosEvaluados = evaluacion.operariosEvaluados || [];
  const isAmarre = evaluacion.tipoReporte === 'amarre';
  const isToolbox = evaluacion.tipoReporte === 'toolbox';
  const reportTitle = getReportTitle(evaluacion);

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        <View style={styles.reportFrame}>
          <View style={styles.topBand} fixed>
            <View style={[styles.topBandCell, styles.topBandSide]}>
              <Image src={logoSrc} style={{ width: 94, height: 26 }} />
            </View>

            <View style={[styles.topBandCell, styles.topBandCenter]}>
              <Text style={styles.reportTitle}>{reportTitle}</Text>
              <Text style={styles.subTitle}>
                Informe generado automaticamente
              </Text>
            </View>

            <View style={[styles.topBandCell, styles.topBandRight]}>
              <Text style={styles.subTitle}>DP WORLD</Text>
            </View>
          </View>

          <View style={styles.infoTable}>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Evaluado</Text>
              <Text style={styles.infoValue}>{evaluacion.nombreEvaluado}</Text>
              <Text style={styles.infoRightLabel}>Fecha</Text>
              <Text style={styles.infoRightValue}>{evaluacion.fecha}</Text>
            </View>

            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Legajo</Text>
              <Text style={styles.infoValue}>
                {evaluacion.legajoEvaluado || '-'}
              </Text>
              <Text style={styles.infoRightLabel}>Reporte</Text>
              <Text style={styles.infoRightValue}>
                {evaluacion.etiquetaReporte || 'TRIANUAL'}
              </Text>
            </View>
          </View>

          {isAmarre && operariosEvaluados.length ? (
            <>
              <View style={styles.sectionBand}>
                <Text style={styles.sectionBandText}>Operarios evaluados</Text>
              </View>

              <View style={styles.operariosTable}>
                <View style={styles.questionHeader}>
                  <Text style={styles.operarioItemCol}>Items</Text>
                  <Text style={styles.operarioLegajoCol}>Legajo</Text>
                  <Text style={styles.operarioNombreCol}>Apellido y Nombre</Text>
                </View>

                {operariosEvaluados.map((operario, index) => (
                  <View
                    key={operario.id}
                    style={[
                      styles.questionRow,
                      index % 2 === 1 ? styles.altRow : null,
                    ]}
                    wrap={false}
                  >
                    <Text style={styles.operarioItemCol}>{operario.item}</Text>
                    <Text style={styles.operarioLegajoCol}>{operario.legajo}</Text>
                    <Text style={styles.operarioNombreCol}>
                      {operario.nombreCompleto}
                    </Text>
                  </View>
                ))}
              </View>
            </>
          ) : null}

          <View style={styles.sectionBand}>
            <Text style={styles.sectionBandText}>
              Resultado de evaluacion / competencia
            </Text>
          </View>

          <View style={styles.questionTable}>
            <View style={styles.questionHeader}>
              <Text style={styles.colNumber}>No</Text>
              <Text style={styles.colQuestion}>Descripcion</Text>
              <Text style={styles.colCompetency}>Competencia</Text>
            </View>

            {evaluacion.preguntas.map((item, index) => (
              <View
                key={item.id}
                style={[
                  styles.questionRow,
                  index % 2 === 1 ? styles.altRow : null,
                ]}
                wrap={false}
              >
                <Text style={styles.colNumber}>{item.id}</Text>
                <Text style={styles.colQuestion}>{item.pregunta}</Text>
                <Text style={styles.colCompetency}>
                  {formatAnswer(item.respuesta)}
                </Text>
              </View>
            ))}
          </View>

          {evidencias.length ? (
            <>
              <View style={styles.sectionBand}>
                <Text style={styles.sectionBandText}>Area de imagenes</Text>
              </View>

              <View style={styles.evidenceGrid}>
                {evidencias.map((item) => (
                  <View key={item.id} style={styles.evidenceCard} wrap={false}>
                    <View style={styles.evidenceFrame}>
                      {item.evidenciaPreview ? (
                        <Image src={item.evidenciaPreview} style={styles.evidenceImage} />
                      ) : (
                        <View style={styles.evidencePlaceholder}>
                          <Text>{item.evidencia}</Text>
                        </View>
                      )}

                      <Text style={styles.evidenceCaption}>
                        {isToolbox
                          ? `Evidencia ${item.id}`
                          : `Pregunta ${item.id} - ${item.evidencia}`}
                      </Text>
                    </View>
                  </View>
                ))}
              </View>
            </>
          ) : null}

          <View style={styles.sectionBand}>
            <Text style={styles.sectionBandText}>Validacion final</Text>
          </View>

          <View style={styles.signatureTable} wrap={false}>
            <View style={styles.signatureHeader}>
              <Text style={styles.signatureCellHeader}>Legajo</Text>
              <Text style={styles.signatureCellHeader}>Firma</Text>
              <Text style={styles.signatureCellHeader}>
                {isAmarre ? 'Inspector' : 'Evaluado por'}
              </Text>
            </View>

            <View style={styles.signatureBody}>
              <View style={styles.signatureCell}>
                <Text>{evaluacion.legajoEvaluado || '-'}</Text>
              </View>

              <View style={styles.signatureCell}>
                {evaluacion.firma ? (
                  <Image src={evaluacion.firma} style={styles.signatureImage} />
                ) : (
                  <Text style={styles.signaturePlaceholder}>Sin firma</Text>
                )}
              </View>

              <View style={[styles.signatureCell, styles.signatureCellLast]}>
                <Text>{evaluacion.nombreResponsable || evaluacion.nombreEvaluado}</Text>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.pageFooter} fixed>
          <View style={styles.pageNumberWrap}>
            <Text
              style={styles.pageNumberText}
              render={({ pageNumber, totalPages }) => `${pageNumber}/${totalPages}`}
            />
          </View>
          <Text style={styles.pageMetaText}>Area de impresion</Text>
        </View>
      </Page>
    </Document>
  );
}

export default InformeEvaluacionPDF;
